/*----------------------------------------------
          sifu slider start v1.1
----------------------------------------------*/
var sifuIsDragging;
var sifuScrolling;
var sifuStartPosition;
function SifuSetAtts(sifu_slider){
    sifu_slider.hide();
    var available_width = sifu_slider.parent().outerWidth();

    sifu_slider.removeAttr('style');
    var sliderWrapper = sifu_slider.find(".slider-wrapper");

    sliderWrapper.removeAttr('style');
    var slides = sifu_slider.find(".slide");
    slides.hide();
    slides.first().show();
    slides.removeAttr('style');
    var slideCount = slides.length;
    var slideWidth = slides.first().outerWidth();

    var screenWidth = window.innerWidth - 80;
    if(slideWidth > screenWidth){
        slideWidth = screenWidth;
    }
    if(slideWidth > available_width){
        slideWidth = available_width;
    }
    
    sliderWrapper.css("width",slideWidth * slideCount);
    sliderWrapper.css("grid-template-columns", "repeat("+slideCount+",max-content)");
    slides.show();
    slides.css("width",slideWidth);
    sifu_slider.css("width",slideWidth);
    
    //var slideWidth = slides.outerWidth();
    var scrollAmount = slideWidth;
    var maxScrollLeft = sliderWrapper.width() - slideWidth;

    sifu_slider.data("slideCount",slideCount);
    sifu_slider.data("slideWidth",slideWidth);
    sifu_slider.data("maxScrollLeft",maxScrollLeft);
    sifu_slider.data("scrollAmount",scrollAmount);
    sifu_slider.data("sliderLoaded","true");
    //sifu_slider.show();
}

$(document).ready(function() {
    $('.sifu-slider').each(function( index, element){
        sifu_slider = $(element);
        SifuSetAtts(sifu_slider);
    });
});



  
  
$(".sifu-nav .arrow.left").on('click', function() {
    var sifu_slider = $(this).closest(".sifu-nav").prev(".sifu-slider");
    var sliderWrapper = sifu_slider.find(".slider-wrapper");
    var arrowLeft = sifu_slider.next(".sifu-nav").find(".arrow.left");
    var arrowRight = sifu_slider.next(".sifu-nav").find(".arrow.right");

    var currentScrollLeft = sliderWrapper.scrollLeft();
    var newScrollLeft = currentScrollLeft - sifu_slider.data("scrollAmount");
    var currentScrollLeft = sliderWrapper.scrollLeft();

    if (sifu_slider.scrollLeft() <= 0) {
        arrowLeft.addClass('inactive');
        return false;
    }

    var newScrollLeft = currentScrollLeft - sifu_slider.data("scrollAmount");
    sifu_slider.css("scroll-snap-type","none");
    sifu_slider.animate({
        scrollLeft: "+=" + newScrollLeft
    }, 400, function() {
        sifu_slider.css("scroll-snap-type","x mandatory");
        //nav classes
        if (sifu_slider.scrollLeft() <= 0) {
            arrowLeft.addClass('inactive');
        }
        if (sifu_slider.scrollLeft() > 0) {
            arrowLeft.removeClass('inactive');
        }
        if (sifu_slider.scrollLeft() >= sifu_slider.data("maxScrollLeft")) {
            arrowRight.addClass('inactive');
        }
        if (sifu_slider.scrollLeft() < sifu_slider.data("maxScrollLeft")) {
            arrowRight.removeClass('inactive');
        }
    });
});
  
$(".sifu-nav .arrow.right").on('click', function() {
    var sifu_slider = $(this).closest(".sifu-nav").prev(".sifu-slider");
    var sliderWrapper = sifu_slider.find(".slider-wrapper");
    var arrowLeft = sifu_slider.next(".sifu-nav").find(".arrow.left");
    var arrowRight = sifu_slider.next(".sifu-nav").find(".arrow.right");

    var currentScrollLeft = sliderWrapper.scrollLeft();
    var newScrollLeft = currentScrollLeft + sifu_slider.data("scrollAmount");
    //console.log(sifu_slider.data("scrollAmount"));

    
    if (sifu_slider.scrollLeft() >= sifu_slider.data("maxScrollLeft")) {
        arrowRight.addClass('inactive');
        return false;
    }

    var newScrollLeft = currentScrollLeft + sifu_slider.data("scrollAmount");
    sifu_slider.css("scroll-snap-type","none");
    sifu_slider.animate({
      scrollLeft: "+=" + newScrollLeft
    }, 400, function() {
        sifu_slider.css("scroll-snap-type","x mandatory");
        //nav classes
        if (sifu_slider.scrollLeft() <= 0) {
            arrowLeft.addClass('inactive');
        }
        if (sifu_slider.scrollLeft() > 0) {
            arrowLeft.removeClass('inactive');
        }
        if (sifu_slider.scrollLeft() >= sifu_slider.data("maxScrollLeft")) {
            arrowRight.addClass('inactive');
        }
        if (sifu_slider.scrollLeft() < sifu_slider.data("maxScrollLeft")) {
            arrowRight.removeClass('inactive');
        }
    });
});


$('.sifu-slider').on('mousedown', function(e) {
    var sifu_slider = $(this);
    if(sifuScrolling){
        return false;
    }
    sifu_slider.css("scroll-snap-type","none");
    sifuIsDragging = true;
    sifuStartPosition = e.pageX || e.originalEvent.touches[0].pageX;
});
  
$(document).on('mouseup', function() {
    if(sifuScrolling){
        return false;
    }
    //sliderContainer.css("scroll-snap-type","x mandatory");
    sifuIsDragging = false;
});
  
$('.sifu-slider').on('mousemove', function(e) {
    var sifu_slider = $(this);
    var arrowLeft = sifu_slider.next(".sifu-nav").find(".arrow.left");
    var arrowRight = sifu_slider.next(".sifu-nav").find(".arrow.right");
    var sliderWrapper = sifu_slider.find(".slider-wrapper");


    sifu_slider.next(".sifu-nav").find(".arrow.left")
    if (sifuIsDragging) {
        if(sifuScrolling){
            return false;
        }
        var currentPosition = e.pageX || e.originalEvent.touches[0].pageX;
        var distance = currentPosition - sifuStartPosition;
        var currentScrollLeft = sliderWrapper.scrollLeft();

        if (distance < -50) {

            if (sifu_slider.scrollLeft() >= sifu_slider.data("maxScrollLeft")) {
                arrowRight.addClass('inactive');
                return false;
            }
            
            sifuScrolling = true;
            var newScrollLeft = currentScrollLeft + sifu_slider.data("scrollAmount");
            sifu_slider.animate({
                scrollLeft: "+=" + newScrollLeft
            }, 400, function() {
                
                sifuScrolling = false;
                sifuIsDragging = false;

                sifu_slider.css("scroll-snap-type","x mandatory");
                //nav classes
                if (sifu_slider.scrollLeft() <= 0) {
                    arrowLeft.addClass('inactive');
                }
                if (sifu_slider.scrollLeft() > 0) {
                    arrowLeft.removeClass('inactive');
                }
                if (sifu_slider.scrollLeft() >= sifu_slider.data("maxScrollLeft")) {
                    arrowRight.addClass('inactive');
                }
                if (sifu_slider.scrollLeft() < sifu_slider.data("maxScrollLeft")) {
                    arrowRight.removeClass('inactive');
                }

            });
        }
        if (distance > 50) {
            if (sifu_slider.scrollLeft() <= 0) {
                arrowLeft.addClass('inactive');
                return false;
            }

            sifuScrolling = true;
            var newScrollLeft = currentScrollLeft - sifu_slider.data("scrollAmount");
            sifu_slider.animate({
                scrollLeft: "+=" + newScrollLeft
            }, 400, function() {
                sifuScrolling = false;
                sifuIsDragging = false;

                sifu_slider.css("scroll-snap-type","x mandatory");
                //nav classes
                if (sifu_slider.scrollLeft() <= 0) {
                    arrowLeft.addClass('inactive');
                }
                if (sifu_slider.scrollLeft() > 0) {
                    arrowLeft.removeClass('inactive');
                }
                if (sifu_slider.scrollLeft() >= sifu_slider.data("maxScrollLeft")) {
                    arrowRight.addClass('inactive');
                }
                if (sifu_slider.scrollLeft() < sifu_slider.data("maxScrollLeft")) {
                    arrowRight.removeClass('inactive');
                }
            });
        }
    }
});

$(window).on('resize', function() {
    $('.sifu-slider').each(function(){
        var sifu_slider = $(this);
        if(sifu_slider.data("sliderLoaded")=="true"){
            SifuSetAtts(sifu_slider);
        }
    });
});

